module.exports = __webpack_public_path__ + "static/media/coming_soon.1cf30592.jpg";